import React from 'react';
import './AccessibleLegalContent.css'; 


function transformHtmlContent(htmlContent) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  
  const paragraphs = Array.from(doc.querySelectorAll('p'));
  
  let titleParagraph = null;
  let listItems = [];
  
  for (let i = 0; i < paragraphs.length; i++) {
    const text = paragraphs[i].textContent.trim();
    if (text.startsWith('-')) {
      if (listItems.length === 0 && i > 0) {
        titleParagraph = paragraphs[i-1];
      }
      listItems.push(paragraphs[i]);
    }
  }
  
  if (listItems.length > 0) {
    const ul = doc.createElement('ul');
    ul.className = 'legal-list';
    
    listItems.forEach((p) => {
      const li = doc.createElement('li');
      
      let text = p.textContent.trim();
      if (text.startsWith('-')) {
        text = text.substring(1).trim();
      }
      
      li.textContent = text;
      li.className = 'legal-list-item';
      
      ul.appendChild(li);
      
      if (p.parentNode) {
        p.parentNode.removeChild(p);
      }
    });
    
    if (titleParagraph && titleParagraph.parentNode) {
      titleParagraph.parentNode.insertBefore(ul, titleParagraph.nextSibling);
    } 
    else if (doc.body.firstElementChild) {
      doc.body.firstElementChild.after(ul);
    }
    else {
      doc.body.appendChild(ul);
    }
  }
  
  return doc.body.innerHTML;
}


const AccessibleLegalContent = ({ htmlContent, className }) => {
  const transformedHtml = transformHtmlContent(htmlContent);
  
  return (
    <div 
      className={`${className} legal-content-container`}
      dangerouslySetInnerHTML={{ __html: transformedHtml }} 
    />
  );
};

export default AccessibleLegalContent;